
/* eslint-disable */
import { v4 as uuidv4 } from 'uuid';

export default {
    setDietaryOptions(state, payload) {
        state.dietaryOptions = payload
    },
}